import script from "./InstructionLibraryView.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstructionLibraryView.vue?vue&type=script&lang=ts&setup=true"

import "./InstructionLibraryView.vue?vue&type=style&index=0&id=498b61e0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498b61e0"]])

export default __exports__